export const NUVEM_PAGO_COMMONS_BASE_ROUTE = '/nuvempago-commons';

export const NUVEM_PAGO_COMMONS_ROUTES = {
  blockedAlert: `${NUVEM_PAGO_COMMONS_BASE_ROUTE}/blocked-alert`,
  NUVEM_PAGO_COMMONS_BASE_ROUTE,
};
